<template>
  <a-layout class="work-layout">
    <div class="header-bgaimg">
      <div class="header-serach">
        <a-input
          :placeholder="$t('documentCenter_仓文档中心为开发者提供更优质的文档服务')" class="login-input"
          style="width:477px;height:48px;border-top-right-radius:0px;border-bottom-right-radius:0px;"
          v-model="serachValue"
          @keyup.enter="serachDocBtn"
        />
        <span @click="serachDocBtn"><img src="@/assets/c1.png" alt=""></span>
      </div>
      <div class="header-describe">{{$t('documentCenter_易仓文档中心为开发者提供更优质的文档服务')}}</div>
    </div>
    <a-layout-content style="background:#fff">
      <router-view />
    </a-layout-content>
    <Footer style="background: transparent"/>
  </a-layout>
</template>

<script>
import Footer from '@/components/Footer'
import { docQueryList } from '@/api/login'
import { openNotificationWithIcon } from '@/utils/util'

export default {
  components: {
    Footer
  },
  data () {
    return {
      serachValue: ''
    }
  },
  methods: {
    serachDocBtn () {
      if (!this.serachValue) return
      let data = {
        content: this.serachValue,
        pageNum: 1,
        pageSize: 10
      }
      docQueryList(data).then((res) => {
        if (res.code === '200') {
          let searchobj = {
            total: res.total,
            content: this.serachValue,
            pageNum: res.pageNum,
            list: res.dataList
          }
          this.$store.commit('SERACHDOC', searchobj)
          this.$router.push({ path: '/seachDoc' })
        } else {
          openNotificationWithIcon(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.work-layout {
  .header-bgaimg {
    width: 100%;
    height: 244px;
    background: url('~@/assets/y1.png') no-repeat top center;
    background-size: 100% 100%;
  }
  .header-serach {
    margin-top: 50 + 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      cursor: pointer;
      display: inline-block;
      width: 72px;
      height: 48px;
      line-height: 48px;
      background: #4978D6;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .header-describe {
    margin-top: 26px;
    font-weight:400;
    font-size:18px;
    color:rgba(152,152,152,1);
  }
}
</style>
